// Challenge links survive the existing email and Google sign-in flows.
const RETURN_KEY = "hhkd.squab.return";
export function rememberSquab(path) {
  if (/^\/squab\/squab_[a-f0-9]+$/.test(path)) {
    try { sessionStorage.setItem(RETURN_KEY, path); } catch {}
  }
}
export function takeSquabReturn(fallback) {
  try {
    const path = sessionStorage.getItem(RETURN_KEY);
    sessionStorage.removeItem(RETURN_KEY);
    if (/^\/squab\/squab_[a-f0-9]+$/.test(path || "")) return path;
  } catch {}
  return fallback;
}
export const squabUrl = (id) => `${window.location.origin}/squab/${encodeURIComponent(id)}`;
export const squabTime = (seconds) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

export function squabPresentation(battle) {
  if (battle?.finished) {
    if (!battle.is_participant) return { kind: "closed", brand: "SQUAB WIT DA HOMIE", heading: "This Squab is complete." };
    if (battle.winner === "tie") return { kind: "tie", brand: "SQUAB WIT DA HOMIE", heading: "IT'S A TIE!" };
    const won = !battle.viewer_role || battle.winner === battle.viewer_role;
    return { kind: won ? "winner" : "loser", brand: "SQUAB WIT DA HOMIE",
      heading: won ? "🏆 YOU BODIED FAM!" : "🍗 YOU GOT COOKED!",
      body: won ? "You took this round." : "Your homie took this round." };
  }
  if (battle?.viewer_role === "challenger" && battle.challenger_done) {
    return { kind: "challenge", brand: "HIP-HOP KNOWLEDGE DROP", heading: "🥊 YOU WANT SMOKE?",
      body: "I just handled this Hip-Hop crossword.", prompt: "THINK YOU KNOW MORE THAN ME?" };
  }
  return { kind: "invitation", brand: "HIP-HOP KNOWLEDGE DROP PRESENTS", heading: "🥊 SQUAB WIT DA HOMIE",
    body: "Your homie says your Hip-Hop knowledge ain’t what you think it is.",
    prompt: "Same crossword. Same clues. Fastest clean finish takes the W." };
}

export function squabShareText(battle) {
  if (!battle.finished || battle.challenger_seconds == null || battle.opponent_seconds == null) {
    return `${battle.challenger_name} wants to Squab Wit Da Homie! 🥊 YOU WANT SMOKE? I just handled this Hip-Hop crossword. THINK YOU KNOW MORE THAN ME? Same crossword. Same clues. Fastest clean finish takes the W. Times stay hidden until both finish.`;
  }
  const outcome = battle.winner === "tie" ? "It's a tie!" : `${battle.winner_name} wins!`;
  const headline = battle.winner === "tie" ? "" : `${squabPresentation(battle).heading} `;
  const taunt = (battle.trash_talk || "").replace(/YOU (?:SERVED|COOKED) HIM!/gi, "YOU BODIED FAM!");
  return `${headline}${outcome} ${battle.challenger_name} ${squabTime(battle.challenger_seconds)} vs ${battle.opponent_name} ${squabTime(battle.opponent_seconds)}. ${taunt}`.trim();
}

export async function squabCard(battle) {
  const canvas = document.createElement("canvas");
  canvas.width = 1080; canvas.height = 1080;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Cards aren't supported in this browser. Copy the challenge link instead.");
  const view = squabPresentation(battle);
  const center = view.kind !== "invitation";
  const rounded = (x, y, width, height, radius, fill, border) => {
    ctx.fillStyle = fill;
    if (typeof ctx.roundRect === "function") {
      ctx.beginPath(); ctx.roundRect(x, y, width, height, radius); ctx.fill();
      if (border) { ctx.strokeStyle = border; ctx.lineWidth = 2; ctx.stroke(); }
    } else { ctx.fillRect(x, y, width, height); }
  };
  ctx.fillStyle = "#111312"; ctx.fillRect(0, 0, 1080, 1080);
  rounded(24, 24, 1032, 1032, 42, "#242424", "#303230");
  const line = (text, y, size = 36, color = "#f6f6f3", alignCenter = center) => {
    ctx.fillStyle = color;
    let fontSize = size;
    do { ctx.font = `bold ${fontSize--}px Arial, sans-serif`; } while (ctx.measureText(String(text)).width > 936 && fontSize > 8);
    ctx.textAlign = alignCenter ? "center" : "left";
    ctx.fillText(String(text), alignCenter ? 540 : 72, y);
  };
  const wrap = (text, y, size = 36, color = "#f6f6f3") => {
    ctx.font = `bold ${size}px Arial, sans-serif`;
    let row = "";
    for (const word of String(text).split(" ")) {
      const next = row ? `${row} ${word}` : word;
      if (row && ctx.measureText(next).width > 936) { line(row, y, size, color); y += size * 1.4; row = word; }
      else row = next;
    }
    if (row) line(row, y, size, color);
    return y + size * 1.4;
  };
  line(view.brand, 105, 28, "#b3b5b3");
  line(view.heading, 215, 62);
  const completed = battle.finished && battle.is_participant && battle.challenger_seconds != null && battle.opponent_seconds != null;
  let buttonText;
  if (completed) {
    if (view.body) line(view.body, 310, 38, "#b3b5b3");
    line(battle.title, 390, 30, "#b3b5b3");
    line(`${battle.challenger_name} vs ${battle.opponent_name}`, 465, 36);
    line(`${squabTime(battle.challenger_seconds)}  vs  ${squabTime(battle.opponent_seconds)}`, 545, 62);
    line(battle.winner === "tie" ? "IT'S A TIE!" : `${battle.winner_name} WINS!`, 615, 34);
    if (battle.trash_talk) line(battle.trash_talk.replace(/YOU (?:SERVED|COOKED) HIM!/gi, "YOU BODIED FAM!"), 670, 30, "#b3b5b3");
    buttonText = view.kind === "tie" ? "Rematch" : "RUN IT BACK! 🔥";
  } else {
    let y = wrap(view.body || "This Squab is complete.", 305, 36);
    if (view.prompt) y = wrap(view.prompt, y + 20, view.kind === "challenge" ? 42 : 34);
    line(battle.title, Math.max(525, y + 20), 28, "#b3b5b3");
    line(`${battle.challenger_name} vs ${battle.opponent_name || "a homie"}`, Math.max(580, y + 75), 34);
    line("Times revealed when both players finish.", 665, 28, "#b3b5b3");
    buttonText = view.kind === "challenge" ? "SQUAB WIT DA HOMIE" : "ACCEPT THE SMOKE 💨";
  }
  rounded(64, 730, 952, 108, 24, "#20352a");
  line(buttonText, 798, 38, "#f6f6f3", true);
  line(window.location.host, 920, 26, "#b3b5b3", true);
  line(squabUrl(battle.challenge_id), 990, 20, "#b3b5b3", true);
  return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error("Couldn't create the card")), "image/png"));
}

export async function shareSquab(battle, card) {
  const url = squabUrl(battle.challenge_id);
  const text = squabShareText(battle);
  // Start native sharing within the button gesture; card download is a separate action.
  if (typeof navigator.share === "function") {
    const payload = { title: "Squab Wit Da Homie · HHKD", text, url };
    if (card && typeof File === "function" && typeof navigator.canShare === "function") {
      const files = [new File([card], "HHKD-Squab.png", { type: "image/png" })];
      if (navigator.canShare({ files })) payload.files = files;
    }
    await navigator.share(payload);
    return "shared";
  }
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(`${text}\n${url}`);
    return "copied";
  }
  throw new Error("Copy the challenge link shown below to share.");
}
export async function saveSquabCard(battle) {
  const blob = await squabCard(battle);
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url; link.download = `HHKD-${battle.challenge_id}.png`;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
